import React from 'react';
import './BookUs.css';

const BookUs = () => {
  return (
    <div className="book-us-container">
      {/* Hero Background Section - Only for Title */}
      <div className="bookus-hero">
        <div className="bookus-hero-overlay">
          <h1 className="booking-title">Book Us for Speaking Engagements</h1>
          <p className="booking-subtitle">
            Invite Abstinent Adolescents to speak at your school, church, or community event. 
            We share our message of purpose with youth across the nation.
          </p>
        </div>
      </div>

      {/* Content Section - Plain Background */}
      <div className="bookus-content">
        <div className="booking-info">
            <h2>What We Offer</h2>
            <div className="offerings-grid">
              <div className="offering-card">
                <div className="offering-icon">🎤</div>
                <h3>Speaking Engagements</h3>
                <p>Inspiring talks on abstinence, faith, and making positive life choices</p>
              </div>
              <div className="offering-card">
                <div className="offering-icon">📚</div>
                <h3>Educational Workshops</h3>
                <p>Interactive sessions that educate youth on the benefits of abstinence</p>
              </div>
              <div className="offering-card">
                <div className="offering-icon">⛪</div>
                <h3>Church Events</h3>
                <p>Faith-based presentations that align with Christian values</p>
              </div>
              <div className="offering-card">
                <div className="offering-icon">🏫</div>
                <h3>School Programs</h3>
                <p>Age-appropriate presentations for middle and high school students</p>
              </div>
            </div>
          </div>

        <div className="calendar-section">
          <h2>Interested in a Speaking Engagement?</h2>
          <p className="calendar-description">
            Schedule an inquiry meeting
          </p>
          <a
            href="https://calendly.com/jayric3972/30min"
            target="_blank"
            rel="noopener noreferrer" 
            className="calendar-button"
          >
            View Our Calendar
          </a>
          <div className="contact-alternative">
            <p>Prefer to reach out directly?</p>
            <a href="mailto:abstinentadolescents@gmail.com" className="email-link">
              abstinentadolescents@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookUs;
